module.exports = __webpack_public_path__ + "static/media/no_active_page_found.8c3d2a79.svg";